// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "actioncable" + "-" + "a828b1551cd006ca4e4e" + ".js";
};